// src/utils/withLang.js
import i18n from '../i18n';

export function withLang(path, lang) {
  if (/^https?:\/\//i.test(path)) return path
  const l = (lang || i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  return `/${l}${path.startsWith('/') ? path : '/' + path}`;
}